import { motion } from "framer-motion";
import { TEAM } from "@/data/content";

export const Team = () => {
  return (
    <section
      id="equipo"
      data-testid="team-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 md:py-32"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-green mb-5">
            El equipo
          </p>
          <h2 className="font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.9]">
            Pequeñas en tamaño.{" "}
            <span className="text-green">Gigantes</span> en creatividad.
          </h2>
          <p className="mt-6 text-ink/60 text-base md:text-lg max-w-md leading-relaxed">
            Detrás de <span className="lowercase font-semibold text-ink">isavicente</span> hay un
            equipo especializado que combina diseño, estrategia y una obsesión sana
            por los buenos resultados.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 md:gap-5">
          {TEAM.map((t, i) => (
            <motion.div
              key={t.role}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`team-card-${i}`}
              className={`group relative overflow-hidden rounded-3xl aspect-[3/4] ${
                i === 1 ? "sm:mt-16" : ""
              }`}
            >
              <img
                src={t.image}
                alt={t.role}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-[800ms] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent" />
              <div className="absolute bottom-0 p-6 md:p-7">
                <p className="text-mango text-xs font-bold tracking-[0.2em] uppercase mb-2">
                  {t.focus}
                </p>
                <h3 className="font-display font-bold text-2xl md:text-3xl text-white tracking-tight mb-2">
                  {t.role}
                </h3>
                <p className="text-white/80 text-sm max-w-[240px] leading-relaxed">
                  {t.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
